// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===genral-css==== */
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body,
html {
  font-family: "Poppins", sans-serif;
  background: #f4f5f7;
  overflow-x: hidden;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  position: relative;
  line-height: 21px;
  height: 100%;
}
::selection {
  background-color: #1fcdae;
  color: #fff;
}

.section {
  position: relative;
  padding: 100px 0;
}

.section.section-padding {
  padding: 100px 0 70px;
}

img {
  max-width: 100%;
}

ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

/* Typography */

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins", sans-serif;
  margin-bottom: 20px;
}

p {
  margin-bottom: 10px;
}

a {
  transition: 0.3s;
  display: inline-block;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  text-decoration: none;
}

a:hover,
a:focus {
  outline: none;
  box-shadow: none;
  text-decoration: none;
  /* color: transparent; */
}

.section {
  padding: 50px 0;
}

.section-heading.centred {
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  align-items: center;
}

.section-heading {
  margin-bottom: 40px;
}

/* =======header-styling===== */

.main_header {
  background: #fff;
  padding: 0;
}

.main_header .logo {
  background-color: #d3faff;
  height: 100%;
  margin: 0;
  padding: 10px 18px 10px 30px;
  border-radius: 0 35px 35px 0;
  position: relative;
}

.main_header .logo .hamburger_icon {
  position: absolute;
  right: -15px;
  top: 22%;
  fill: #fff;
  filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.17));
  background: #fff;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
}

.main_header .logo .hamburger_icon img {
  transition: all 0.5s ease;
}

.main_header .logo .hamburger_icon:hover img {
  transform: rotate(360deg);
}

.main_header .header_list .right_wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.main_header .header_search {
  padding-left: 70px;
}

.col-padding-class {
  padding: 0 8px !important;
}

.main_header .header_search input {
  border: 0;
  margin-left: 14px;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.13px;
  width: 400px;
}

.main_header .header_search input:focus {
  outline: none;
}

.main_header .header_search input::placeholder {
  color: #979797;
}
.main_header .header_list .right_wrapper li {
  margin: 1px 13px;
  position: relative;
  height: 100%;
}

.main_header .header_list .right_wrapper li a {
  height: 100%;
}

.main_header .header_list .right_wrapper li .nottification_bedge {
  padding: 10px;
}

.main_header .header_list .right_wrapper li .nottification_bedge span {
  position: absolute;
  height: 15px;
  width: 15px;
  background-color: #f6aa1e;
  color: #fff;
  top: 6px;
  left: 19px;
  z-index: 2;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}

.main_header .header_list .right_wrapper li .nottification_bedge:hover span {
  height: 17px;
  width: 17px;
}

.main_header .header_list .right_wrapper li .dropdown_list span {
  color: #00223f;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 130.5%;
  letter-spacing: 0.15px;
  display: inline-block;
  transition: all 0.5s ease;
}

.main_header .header_list .right_wrapper li .dropdown_list span:hover {
  color: #f6aa1e;
}

.main_header .header_list .right_wrapper li .dropdown_list svg {
  color: #f6aa1e;
  margin-top: 10px;
  position: relative;
  top: 4px;
}

.home_flex_container {
  display: flex;
  flex-wrap: nowrap;
}

.page_navigation {
  padding: 20px 16px 18px;
}

.page_navigation ul {
  display: flex;
  align-items: center;
}

.page_navigation ul li svg {
  margin: 0 5px;
}

.page_navigation ul li.back_link {
  padding-right: 19px;
}

.page_navigation ul li.back_link a {
  color: #00223f;
  position: relative;
  top: 2px;
  transition: all 0.5s ease;
  visibility: hidden;
}

.page_navigation ul li.disable_link {
  color: #979797;
}

.page_navigation ul li.Announcement a {
  color: #00223f;
  position: relative;
  top: 2px;
  transition: all 0.5s ease;
}

.page_navigation ul li.Announcement a:hover,
.page_navigation ul li.back_link a:hover {
  color: #f79418;
}

.page_navigation ul li {
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.11px;
}

.no_padding {
  padding: 0 8px;
}

.padding_left_none {
  padding-left: 18px;
}

.main_dashboard .padding_left_none {
  padding-left: 15px;
}

._3curk {
  z-index: 2;
}
.home_flex_container {
  overflow: hidden;
  overflow-y: scroll;
  margin-bottom: 16px;
}
.profile_user .profile_image {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/header.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;AACA;;EAEE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;;AAEA,eAAe;;AAEf;;;;;;EAME,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,oDAAoD;EACpD,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* ===genral-css==== */\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\nbody,\nhtml {\n  font-family: \"Poppins\", sans-serif;\n  background: #f4f5f7;\n  overflow-x: hidden;\n  font-size: 20px;\n  font-weight: 300;\n  font-style: normal;\n  position: relative;\n  line-height: 21px;\n  height: 100%;\n}\n::selection {\n  background-color: #1fcdae;\n  color: #fff;\n}\n\n.section {\n  position: relative;\n  padding: 100px 0;\n}\n\n.section.section-padding {\n  padding: 100px 0 70px;\n}\n\nimg {\n  max-width: 100%;\n}\n\nul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n\n/* Typography */\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Poppins\", sans-serif;\n  margin-bottom: 20px;\n}\n\np {\n  margin-bottom: 10px;\n}\n\na {\n  transition: 0.3s;\n  display: inline-block;\n  cursor: pointer;\n  overflow: hidden;\n  position: relative;\n  text-decoration: none;\n}\n\na:hover,\na:focus {\n  outline: none;\n  box-shadow: none;\n  text-decoration: none;\n  /* color: transparent; */\n}\n\n.section {\n  padding: 50px 0;\n}\n\n.section-heading.centred {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.section-heading {\n  margin-bottom: 40px;\n}\n\n/* =======header-styling===== */\n\n.main_header {\n  background: #fff;\n  padding: 0;\n}\n\n.main_header .logo {\n  background-color: #d3faff;\n  height: 100%;\n  margin: 0;\n  padding: 10px 18px 10px 30px;\n  border-radius: 0 35px 35px 0;\n  position: relative;\n}\n\n.main_header .logo .hamburger_icon {\n  position: absolute;\n  right: -15px;\n  top: 22%;\n  fill: #fff;\n  filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.17));\n  background: #fff;\n  padding: 10px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.main_header .logo .hamburger_icon img {\n  transition: all 0.5s ease;\n}\n\n.main_header .logo .hamburger_icon:hover img {\n  transform: rotate(360deg);\n}\n\n.main_header .header_list .right_wrapper {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.main_header .header_search {\n  padding-left: 70px;\n}\n\n.col-padding-class {\n  padding: 0 8px !important;\n}\n\n.main_header .header_search input {\n  border: 0;\n  margin-left: 14px;\n  font-family: Poppins;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.13px;\n  width: 400px;\n}\n\n.main_header .header_search input:focus {\n  outline: none;\n}\n\n.main_header .header_search input::placeholder {\n  color: #979797;\n}\n.main_header .header_list .right_wrapper li {\n  margin: 1px 13px;\n  position: relative;\n  height: 100%;\n}\n\n.main_header .header_list .right_wrapper li a {\n  height: 100%;\n}\n\n.main_header .header_list .right_wrapper li .nottification_bedge {\n  padding: 10px;\n}\n\n.main_header .header_list .right_wrapper li .nottification_bedge span {\n  position: absolute;\n  height: 15px;\n  width: 15px;\n  background-color: #f6aa1e;\n  color: #fff;\n  top: 6px;\n  left: 19px;\n  z-index: 2;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.main_header .header_list .right_wrapper li .nottification_bedge:hover span {\n  height: 17px;\n  width: 17px;\n}\n\n.main_header .header_list .right_wrapper li .dropdown_list span {\n  color: #00223f;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 130.5%;\n  letter-spacing: 0.15px;\n  display: inline-block;\n  transition: all 0.5s ease;\n}\n\n.main_header .header_list .right_wrapper li .dropdown_list span:hover {\n  color: #f6aa1e;\n}\n\n.main_header .header_list .right_wrapper li .dropdown_list svg {\n  color: #f6aa1e;\n  margin-top: 10px;\n  position: relative;\n  top: 4px;\n}\n\n.home_flex_container {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.page_navigation {\n  padding: 20px 16px 18px;\n}\n\n.page_navigation ul {\n  display: flex;\n  align-items: center;\n}\n\n.page_navigation ul li svg {\n  margin: 0 5px;\n}\n\n.page_navigation ul li.back_link {\n  padding-right: 19px;\n}\n\n.page_navigation ul li.back_link a {\n  color: #00223f;\n  position: relative;\n  top: 2px;\n  transition: all 0.5s ease;\n  visibility: hidden;\n}\n\n.page_navigation ul li.disable_link {\n  color: #979797;\n}\n\n.page_navigation ul li.Announcement a {\n  color: #00223f;\n  position: relative;\n  top: 2px;\n  transition: all 0.5s ease;\n}\n\n.page_navigation ul li.Announcement a:hover,\n.page_navigation ul li.back_link a:hover {\n  color: #f79418;\n}\n\n.page_navigation ul li {\n  font-family: Poppins;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  letter-spacing: 0.11px;\n}\n\n.no_padding {\n  padding: 0 8px;\n}\n\n.padding_left_none {\n  padding-left: 18px;\n}\n\n.main_dashboard .padding_left_none {\n  padding-left: 15px;\n}\n\n._3curk {\n  z-index: 2;\n}\n.home_flex_container {\n  overflow: hidden;\n  overflow-y: scroll;\n  margin-bottom: 16px;\n}\n.profile_user .profile_image {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
